import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const getTransactionReport = (params) => {
    return axios.get(`${backendHost}/api/admin/replenishment/transaction`, {params});
};